import { render, staticRenderFns } from "./AskHeader.vue?vue&type=template&id=540e5029&scoped=true&"
import script from "./AskHeader.vue?vue&type=script&lang=js&"
export * from "./AskHeader.vue?vue&type=script&lang=js&"
import style0 from "./AskHeader.vue?vue&type=style&index=0&id=540e5029&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e5029",
  null
  
)

export default component.exports